import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import moment from 'moment'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
var firebase = require('firebase/app')
import emailjs from 'emailjs-com'
require('firebase/auth')
//require('firebase/database')
require('firebase/firestore') 
require("firebase/storage");
//require('firebase/messaging')
//require('firebase/functions')
const firebaseConfig = {
  apiKey: "AIzaSyDB325CQC3MpYujdd57ABvbQ5LUtEGUvn0",
  authDomain: "pipemein.firebaseapp.com",
  databaseURL: "https://pipemein.firebaseio.com",
  projectId: "pipemein",
  storageBucket: "pipemein.appspot.com",
  messagingSenderId: "621975422719",
  appId: "1:621975422719:web:db4ccf66c26e29ac71aeca",
  measurementId: "G-1QXMPL385E"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
export default firebaseApp.firestore();

Vue.use(Vuetify)

Vue.config.productionTip = false

firebase.auth().onAuthStateChanged((user) =>{

  if (user) {
    store.commit('setUsuario', user) 
    store.dispatch('detectarUsuario')
}
  new Vue({
    router,
    store,
    vuetify,
  render: h => h(App)
}).$mount('#app')
})

